import dayjs from 'dayjs';

/**
 * Format the street address of a load stop
 * @param {string} stop - The load stop object
 * @returns {string} - The formatted street address.
 */
export const formattedStreetAddress = (stop) => {
  return `${stop.street1 || ''}`;
};

/**
 * Format the address of a load stop
 * @param {string} stop - The load stop object
 * @returns {string} - The formatted address with city/state.
 */
export const formattedCityStateAddress = (stop) => {
  return `${stop.city || stop.area_five_zip_city || '-'}, ${stop.state || stop.area_five_zip_state || '-'}`;
};

/**
 * Format the status of the load
 * @param {string} status - The load status
 * @returns {string} - The formatted status text of a load
 */
export const formatLoadStatus = (status) => {
  switch (status) {
    case 'covered':
      return 'Covered';
    case 'progress':
      return 'Progress';
    case 'assumed_delivered':
      return 'Delivered';
    case 'assign_vehicle':
    case 'available':
      return 'Assign Vehicle';
    default:
      return null;
  }
};

/**
 * Format the equipment type on a load
 * @param {string} type - The load equipment type
 * @returns {string} - The formatted load equipment type(s)
 */
export const formatEquipmentType = (type) => {
  return type?.reduce((acc, item, index) => {
    if (index == 0) {
      acc += capitalizeWords(item?.replace(/_/g, ' '));
    } else if (index === 1) {
      acc += `, ${capitalizeWords(item?.replace(/_/g, ' '))}`;
    } else if (index === 2) {
      acc += ', etc.';
    }

    return acc;
  }, '');
};

/**
 * Format the stop date on a load
 * @param {string} date - date string
 * @returns {string} - The formatted date on a load stop
 */
export const formatStopDate = (date, timezone, has_time = false) => {
  if (!date) return '-';
  let formatted = dayjs(date);
  if (timezone) {
    formatted = formatted.tz(timezone);
  }

  if (has_time) {
    return formatted.format('MM/DD [•] h:mm a');
  }
  return `${formatted.format('MM/DD [•]')} TBD`;
};

export const formatStopWindow = (stop) => {
  let start = dayjs(stop.scheduled_window_started_at_in_stop_timezone).tz(
    stop.area_timezone || stop.timezone
  );

  let end = dayjs(stop.scheduled_window_ended_at_in_stop_timezone).tz(
    stop.area_timezone || stop.timezone
  );

  if (stop?.has_time === true || stop?.has_time === null) {
    if (start.isSame(end)) {
      return `${start.format('MM/DD [•] h:mm a')}`;
    }
    return `${start.format('MM/DD [•] h:mm a')} - ${end.format('h:mm a')}`;
  }

  return `${start.format('MM/DD [•] ')} TBD`;
};

/**
 * Capitalize each word in a string
 * @param {string} str - The words needed to be capitalized
 * @returns {string} - The capitalized words of the string
 */
export const capitalizeWords = (str) => {
  if (!str) return '';
  return str
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    .replace('Llc', 'LLC');
};

/**
 * Return the type of rate of a load
 * @param {string} rate - The rate per mile of the load
 * @returns {string} - Rate of the load. ex: "Great", "Good"
 */
export const formatLoadRate = (rate) => {
  if (rate?.lane_prediction?.posted_rate_assessment) {
    return rate?.lane_prediction?.posted_rate_assessment;
  }
};
